import { EMPLOYER_REQUEST_STATUS } from 'constants/status.constants';
import { ROLE_CODES } from 'constants/role.constants';
import { ON_BEHALF_ACTIONS, WORKFLOW_SUB_TYPES } from 'constants/certification.constants';
import { SwitchedPhaseInfo } from 'components/switch-phases-notification/switch-phases-notification.component';
import { FeesFormField } from 'components/organization-certification/step/fee/fee-step.interface';
import { SUPERVISOR_APPROVAL_TYPE } from 'constants/log-step.constants';
import { WORKFLOW_MODULE_ID } from 'constants/workflow.constants';

export enum TO_BE_AUDITED {
  FALSE,
  TRUE,
}

export interface OrganizationContactData {
  name: string;
  email?: string;
}

export interface CertificateInstance {
  id: number;
  profile_id: number;
  valid_from_date: string;
  valid_to_date: string;
  current_phase_ins_id: number;
  is_passed_due_date: number;
  name: string;
  acronym: string;
  description: string;
  certification_instance_id: number;
  certification_name: string;
  certification_template_id: number;
  current_phase_name: string;
  organization_name: string;
  organizationEmail: string;
  organization_logo?: string;
  status_id: number;
  status_name: string;
  due_date: string;
  step_instances: StepInstance[];
  step_instances_count: number;
  status_color: number;
  is_rejected: boolean;
  expiration_date?: string;
  request?: EmployerRequest;
  tracked_by: EmployerRequest[];
  on_behalf_indicator: OnBehalfIndicator;
  certification_documents?: CertificateDocument[];
  documents?: CertificateDocument[];
  switch_phase?: SwitchedPhaseInfo;
  certification_logo?: string;
  activePhaseDescription?: string;
  failedNote?: string;
  to_be_audited?: TO_BE_AUDITED;
  typeId: WORKFLOW_MODULE_ID;
  _full?: boolean;
  phases?: any[];
  currentPhase?: any;
  workflowSubtypeId: WORKFLOW_SUB_TYPES;
  expirationDate: Date;
  verificationDate: Date;
  renewalDate: Date;
  certificationVerificationStatusId: string;
  expirationStatus: string;
  certificationNumber: string;
  root_certification_instance_id?: number;
}

export interface RejectStepData {
  isRejected: boolean;
  rejectedByRoleId: ROLE_CODES;
  supervisorLabel?: string;
  isJobRejected?: boolean;
  isSecondarySupervisor?: boolean;
  supervisorApprovalTypeId?: SUPERVISOR_APPROVAL_TYPE;
}

export interface EmployerInfo {
  organization_name: string;
  first_name: string;
  last_name: string;
  profile_id: number;
}

export interface StepInstance {
  step_id: number;
  step_type_id: number;
  status_color: number;
  isPassedDueDate: boolean;
  step_instance_id: number;
  step_type_name: string;
  rejectStepData: RejectStepData;
  status_id: number;
  name: string;
  role?: string;
  status_name: string;
  end_date: string;
  description: string;
  is_interactive: boolean;
  content?: ProgressHours | ProgressEntries | ContentFee;
  paid_by_info?: EmployerInfo;
  on_behalf_indicator?: OnBehalfIndicator;
  isUpcoming?: boolean;
  psi_site_link?: string;
  hasIncompletedDemographicStep?: boolean;
  rejectionNote?: string;
  isRejected?: boolean;
  requiredForCompletion?: boolean;
}

export interface ProgressHours {
  role?: string;
  hours_data: HoursData;
  details?: any;
  unitsDataWithoutAdvancedOptions?: UnitsData;
  unitsData?: UnitsData;
}

export interface UnitsData {
  unitsFull?: number;
  unitsCompleted: number;
  unitsIncompleted?: number;
  unitsPendingVerification: number;
  submittedUnits?: number;
}

export interface HoursData {
  hours_incompleted: number;
  hours_pending_verification: number;
  hours_completed: number;
  hours_full?: number;
}

interface ProgressEntries {
  role?: string;
  compliance_criteria_type_id: number;
  number_required: number;
  number_completed: number;
}

export interface ContentFee {
  role?: string;
  fee: number;
  days_remaining?: number;
  upload_enabled: true;
  uploadAcceptable: boolean;
  feesFormFields?: FeesFormField[];
  isLateFeeEnabled?: boolean;
  lateFee?: number;
  gracePeriod?: number;
}

export interface EmployerRequest {
  agreement_text: string;
  employer_certification_request_id: number;
  profile_id: number;
  role_id: number;
  organization_name: string;
  first_name: string;
  last_name: string;
  image?: string;
}

export interface EmployerRequestUpdate {
  status_id: EMPLOYER_REQUEST_STATUS.ACCEPTED | EMPLOYER_REQUEST_STATUS.DECLINED;
  digital_signature?: string;
}

export interface CertificateStatusChangeEvent {
  certificate_id: number;
  action: CertificateStatusChangeAction;
}

export enum CertificateStatusChangeAction {
  ACCEPT = 'ACCEPT',
  REJECT = 'REJECT',
}

export interface OnBehalfIndicator {
  action: ON_BEHALF_ACTIONS;
  profile: {
    first_name: string;
    last_name: string;
    role_id: ROLE_CODES;
    organization_name: string;
    image?: string;
  };
}

export interface CertificateDocument {
  id?: number;
  evidence_file_id?: number;
  link: string;
  name: string;
  size: number;
  removable?: boolean;
}
